<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.69 10.27l-9-8.5a1 1 0 00-1.38 0l-9 8.5a1 1 0 101.38 1.46l.31-.3V21a1 1 0 001 1h14a1 1 0 001-1v-9.57l.31.3A1 1 0 0021 12a1 1 0 00.73-.31 1 1 0 00-.04-1.42zM18 20H6V9.54l6-5.66 6 5.66z"/><path d="M8.5 11.25a3.5 3.5 0 001.12 2.55A4 4 0 008 17v.5a1 1 0 002 0V17a2 2 0 014 0v.5a1 1 0 002 0V17a4 4 0 00-1.62-3.2 3.5 3.5 0 10-5.88-2.55zm5 0a1.5 1.5 0 11-1.5-1.5 1.5 1.5 0 011.5 1.5z"/></svg>